import { lazy, type ComponentType } from 'react';
import { isChunkLoadError } from './isChunkLoadError';

type ImportFactory<T extends ComponentType<any>> = () => Promise<{ default: T }>;

const RETRY_KEY = '_chunk_retry_ts';
const RETRY_COOLDOWN_MS = 30_000;

export function lazyWithRetry<T extends ComponentType<any>>(importFn: ImportFactory<T>) {
  return lazy(() => {
    const lastRetry = sessionStorage.getItem(RETRY_KEY);
    const recentlyRetried = lastRetry ? Date.now() - Number(lastRetry) < RETRY_COOLDOWN_MS : false;

    return importFn().catch((err) => {
      if (isChunkLoadError(err) && !recentlyRetried) {
        sessionStorage.setItem(RETRY_KEY, Date.now().toString());
        window.location.reload();
      }
      throw err;
    });
  });
}
